import { useState } from "react";
import { NavLink } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

import { useUserFarms } from "api/user";
import LogoutIcon from "components/svg/LogoutIcon";

export default function Nav({ routes }: any) {
  const { user, logout } = useAuth0();

  const farms = useUserFarms(user["https://hasura.io/jwt/claims"]["x-hasura-user-id"]);

  const [isOpen, setIsOpen] = useState(true);

  return (
    <nav className={`bg-blue-600 ${isOpen ? "show w-52 shrink-0" : "w-20"}`} onClick={() => setIsOpen(!isOpen)}>
      <ul className={`list-none pt-5 ${isOpen ? "" : "left-1"} lg:fixed mt-6`}>
        {routes.map((prop: any, index: number) =>
          (!prop.hiddenOnNavBar && !(prop.hiddenOnEmptyEan && farms && !farms.length)) ? (
            <li key={index}>
              <NavLink
                to={prop.path}
                aria-current="page"
                onClick={(e) => e.stopPropagation()}
                className={({ isActive }: any) =>
                  `${isActive ? "bg-white text-blue-600 hover:bg-slate-300" : "hover:bg-blue-800 text-white"} my-2 mx-4 ${
                    isOpen ? "px-4" : ""
                  } 
                  ${prop.path === "/profiles" ? "disable-nav" : "" } 
                  rounded-full text-xs font-medium flex items-center`
                }
              >
                {prop.icon}
                {isOpen ? prop.name : null}
              </NavLink>
            </li>
          ) : null
        )}
      </ul>
      <div
        className={`hover:bg-blue-800 text-white my-2 mx-4 ${
          isOpen ? "px-4 w-44" : "left-1"
        } rounded-full text-xs font-medium flex items-center fixed bottom-6 cursor-pointer`}
        onClick={() => {
          sessionStorage.removeItem("farm_name");
          logout();
        }}
      >
        <LogoutIcon className={isOpen ? "mr-3" : ""} />
        {isOpen ? "Sign Out" : null}
      </div>
    </nav>
  );
}
